import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyledPagingArrow } from './Carousel.styles';
import SVGIcon from '../SVGIcon';
import { colors } from '../css';

const directionObject = { left: 90, right: 270 };

/**
 * PagingDots overwrites the default components used in the pagination of the bottom controls of the Carousel.
 * If we need to change the icon or other functionality of the Carousel dots this is where we would do it.
 */
class PagingArrows extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    arrowColor: PropTypes.string,
    direction: PropTypes.string
  };

  static defaultProps = {
    arrowColor: colors.colorBurgundy,
    direction: 'left'
  };

  getDirection() {
    const { direction } = this.props;
    return directionObject[direction];
  }

  render() {
    const { onClick, arrowColor, direction } = this.props;
    return (
      <StyledPagingArrow direction={direction} onClick={onClick} className={`arrow-${direction}`}>
        <SVGIcon width="60px" selectedIcon="arrow" iconColor={arrowColor} rotate={this.getDirection()} />
      </StyledPagingArrow>
    );
  }
}

export default PagingArrows;
